import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import MasterLayout from './layouts/frontend/MasterLayout';

import UserPublicRoutes from './UserPublicRoutes';
import MemberPrivateRoutes from './MemberPrivateRoutes';
import AdminPrivateRoutes from './AdminPrivateRoutes';

import './assets/frontend/css/variables.css';

import './assets/frontend/css/html-tags.css';
import './assets/frontend/css/html-tags-app.css';
import './assets/frontend/css/fonts.css';
import './assets/frontend/css/colors-grey.css';
import './assets/frontend/css/borders-grey.css';
import './assets/frontend/css/borders-radius.css';
import './assets/frontend/css/hide-show.css';
import './assets/frontend/css/widths-heights.css';

import './assets/frontend/css/panels.css';
import './assets/frontend/css/reveal.css';
import './assets/frontend/css/forms.css';
import './assets/frontend/css/buttons.css';
import './assets/frontend/css/utils.css';

import './assets/frontend/css/borders-app.css';
import './assets/frontend/css/navigation-bar.css';
import './assets/frontend/css/navigation-mobile.css';
import './assets/frontend/css/navigation-desktop.css';
import './assets/frontend/css/colors-app.css';
import './assets/frontend/css/footer.css';
import './assets/frontend/css/spacing-mr.css';
import './assets/frontend/css/spacing.css';
import './assets/frontend/css/z-index.css';

import './assets/frontend/css/album.css';
import './assets/frontend/css/audio-player.css';
import './assets/frontend/css/options-panels.css';

function App() {

	return (
		<div className="App">
			<Router>

						<Routes>
							<Route element={<UserPublicRoutes />}>
								<Route path="/*" exact element={<MasterLayout />} />
							</Route>
							<Route element={<AdminPrivateRoutes />}>
								<Route path="/admin/*" name="Admin" element={<MasterLayout />} />
							</Route>
							<Route element={<MemberPrivateRoutes />}>
								<Route path="/member/*" name="Member" element={<MasterLayout />} />
							</Route>
						</Routes>

			</Router>
		</div>
	);
}

export default App;